import http from './http';

export async function listRooms(params) {
  const { data } = await http.get('/rooms', { params });
  return data;
}

export async function createRoom(payload) {
  const { data } = await http.post('/rooms', payload);
  return data;
}

export async function updateRoom(id, payload) {
  const { data } = await http.put(`/rooms/${id}`, payload);
  return data;
}

export async function deleteRoom(id) {
  const { data } = await http.delete(`/rooms/${id}`);
  return data;
}

export async function assignRoom(payload) {
  const { data } = await http.post('/rooms/assign', payload);
  return data;
}

export async function unassignRoom(payload) {
  const { data } = await http.post('/rooms/unassign', payload);
  return data;
}

export async function getRoomAssignments(roomId) {
  const { data } = await http.get(`/rooms/${roomId}/assignments`);
  return data; // { room, assignments }
}

export async function getActiveRoomAssignment(studentId) {
  const { data } = await http.get(`/rooms/students/${studentId}/active`);
  return data;
}

export async function bulkGenerateRooms(payload) {
  const { data } = await http.post('/rooms/bulk-generate', payload);
  return data;
}

export async function bulkAssignRooms(payload) {
  const { data } = await http.post('/rooms/bulk-assign', payload);
  return data;
}
